import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { submenu } from './sub.menu';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';
import { MenuItemsModel } from '@core/menu/menu.model';
import { AgentDetailResolverService } from './features/page-agent/agent-detail-resolver/agent-detail-resolver.service';

const dataPrivilege: Record<'moduleMenu', MenuItemsModel[]> = {
    moduleMenu: submenu,
};

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Agents,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Agents,
        title: marker('modules.agents.head'),
        loadComponent: () => import('./features/page-agents/page-agents.component').then((c) => c.PageAgentsComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Agents + '/' + RouteEntity.Add,
        title: marker('modules.agents.head'),
        loadComponent: () => import('./features/page-agent/page-agent.component').then((c) => c.PageAgentComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Agents + '/:' + RoutingQueryParamsName.SlrId,
        title: marker('modules.agents.head'),
        loadComponent: () => import('./features/page-agent/page-agent.component').then((c) => c.PageAgentComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
        resolve: {
            agent: AgentDetailResolverService,
        },
    },
    {
        path: RouteEntity.Orders,
        title: marker('modules.orders.head'),
        loadComponent: () => import('./features/page-orders/page-orders.component').then((c) => c.PageOrdersComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
